import { trackingMiddleware } from '@shared/webapp-tracking';
import nativeBridgeMiddleware from '@clearscore/redux.native-bridge-middleware';
import monitoringMiddleware from '@clearscore/redux.monitoring-middleware';
import csAuthMiddleWare from '@clearscore/redux.cs-auth-middleware';

export default function verticalMiddleware(verticalName) {
    return [csAuthMiddleWare, monitoringMiddleware(verticalName), nativeBridgeMiddleware(), trackingMiddleware];
}
